import BaseSplitPage from "../../components/splitpage";
import { notification } from 'antd';
import {FlexContainer, Spinner} from "../../design";
import currencyFormatter from "../../utils/currencyformatter";
import {AmountDivideByHundred} from "../../helper";
import Support from "../../components/support";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import getMenuTabs from "../../utils/getMenuTabs";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import React, {useEffect, useState} from "react";
import {
  ECWID_ORDER_STATUS,
  ECWID_ORDER_STATUS_ERROR,
  MESSAGES,
  SUPPORTED_PAYMENT_TYPES,
  SWIREPAY_URL,
  TabNames,
  LPG_CUSTOMER,
} from "../../appconstants";
import {cancelEcwidOrderByGid, ecwidOrderChargeByGid, getEcwidOrderByGid, getHealthCheck} from "../../api";
import CardPayment from "../../components/cardpayment/CardPayment";
import EcwidLeftSideContent from "./left/EcwidLeftSideContent";
import SmallScreenHeader from "../../components/smallscreen/header";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg";
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";

type Props = {
  history: {
    push: Function,
  },
}

const EcwidPayment = (props: Props) => {

  const { match: { params: { ecwidOrderGid } }, location: { pathname, search } } = props;
  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [order, setOrder] = useState(null);
  const [account, setAccount] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [submitBtnText, setSubmitBtnText] = useState(null);
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState([]);
  const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${ecwidOrderGid}-tap-index`) || 0));
  const defaultAlertConfig = {
    showIcon:false, isOpen:false, hideBtn: true,
    cancel: null, header:null, body: null,
    submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
    showSubmitBtn: false, submit: null, icon: null
  };

  const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);
  const [upiDownTime, setUpiDownTime] = useState(false);

  useEffect( () => {
    if (search) {
      getEcwidOrderWithSearchValue();
    } else {
      getEcwidOrderWithoutSearchValue();
    }
  }, [ecwidOrderGid, search]);

  useEffect(() => {
    const paymentTypes = new Set();
    paymentTypes.add(TabNames.CARD);
    if(account) {
      for (let key in SUPPORTED_PAYMENT_TYPES) {
       account.supportedPaymentTypes && account.supportedPaymentTypes.forEach(value => {
          if(SUPPORTED_PAYMENT_TYPES[key] && SUPPORTED_PAYMENT_TYPES[key].includes(value)) {
            paymentTypes.add(key)
          }
        });
      }
    }
    setSupportedPaymentTypes([...paymentTypes])
  }, [account]);

  useEffect(() => {
    if (order && order.currency && order.amount) {
      setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(order.amount), order.currency)}`)
    }
    setCustomer(order && order.paymentSession && order.paymentSession.paymentMethod && order.paymentSession.paymentMethod.customer);
  }, [order]);

  const redirectBasedOnStatus = (status, ecwidReturnUrl) => {
    if (ECWID_ORDER_STATUS.PENDING !== status) {
      let redirectUrl = ecwidReturnUrl ? ecwidReturnUrl : SWIREPAY_URL;
      let errorMsg = "";
      if(ECWID_ORDER_STATUS.PAID === status) {
        errorMsg = ECWID_ORDER_STATUS_ERROR.PAID
      }
      if(ECWID_ORDER_STATUS.CANCELLED === status) {
        errorMsg = ECWID_ORDER_STATUS_ERROR.CANCELLED;
      }
      const urlPath = redirectUrl.includes("?");
      if (urlPath) {
        redirectUrl = `${redirectUrl}&errorMsg=${errorMsg}`;
      } else if (!urlPath) {
        redirectUrl = `${redirectUrl}?errorMsg=${errorMsg}`;
      }
      window.location = encodeURI(redirectUrl);
    }
  };

  const getEcwidOrderWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setShowSpinner(true);
    try {
      const value = await getEcwidOrderByGid(ecwidOrderGid, search);
      if (value) {
        const { ecwidReturnUrl, status } = value;
        setAccount(value.account);
        setOrder(value);
        redirectBasedOnStatus(status, ecwidReturnUrl);
      }
    } catch (reason) {
      try {
        const value = await getEcwidOrderByGid(ecwidOrderGid, null);
        if (value) { setOrder(value); setAccount(value.account); }
      } catch (e) {
        props.history.push(`${pathname}/error`);
      }
      error(reason);
    } finally {
      setShowSpinner(false);
    }
  };

  const getEcwidOrderWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await getEcwidOrderByGid(ecwidOrderGid, null);
      if (value) {
        const { status, ecwidReturnUrl } = value;
        // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        // }
        setOrder(value);
        setAccount(value.account);
        redirectBasedOnStatus(status, ecwidReturnUrl);
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    } finally {
      setShowSpinner(false)
    }
  };

  const chargeByCard = async (data) => {
    await chargeByGid(data);
  };

  const error = reason => {
    setErrorMessage(null);
    const { data: { message, messageCode }, status } = reason;
    setErrorMessage(message);
    if (status === 500) {
      setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
    }
    setTransactionModalOpen(false);
    resetAlertConfig();
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const chargeByGid = async (data) => {
    setTransactionModalOpen(true);
    try {
      const value = await ecwidOrderChargeByGid(ecwidOrderGid, data);
      if (value) {
        const { paymentSession, ecwidReturnUrl } = value;
        if (paymentSession && paymentSession.nextActionUrl) {
          window.location = paymentSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          window.location = ecwidReturnUrl;
        }, 5000);
        if (ecwidOrderGid) { localStorage.removeItem(`${ecwidOrderGid}-tap-index`) }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const cancelOrder = async () => {
    setAlertConfig({...defaultAlertConfig,
      showIcon: true, isOpen: true, hideBtn: true,
      header: `Please Wait!. Your Order cancel is being processed`, body: "You will be redirected when the cancel is successful.",
    });
    if(order && order.gid) {
      try {
        const value = await cancelEcwidOrderByGid(order.gid);
        if (value) {
          const {ecwidReturnUrl } = value;
          setAlertConfig({...defaultAlertConfig,
            showIcon:true, isOpen:true, hideBtn: true,
            header: "Order cancel Completed", body: "You will be redirected automatically.",
            icon: SUCCESS_ICON
          });
          setTimeout(function () {
            window.location = ecwidReturnUrl || SWIREPAY_URL;
          }, 5000);
        }
      } catch (reason) {
        error(reason)
      }
    }
  };

  const cancelAlertOpen = () => {
    setAlertConfig({
      showIcon:true, isOpen:true, hideBtn: false,
      cancel: resetAlertConfig, header: "Are you sure!", body: "You will not be able to recover this order",
      submitBtnText: "Yes, cancel it!", cancelBtnText: "Cancel", showCancelBtn: true,
      showSubmitBtn: true, submit: cancelOrder, icon: WARNING_ICON
    });
  };

  const resetAlertConfig = () => {
    setAlertConfig(defaultAlertConfig)
  };


  const tabPanels = [
    {
      children: <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByCard}
        preFillCustomer={customer}
        headerText={"Pay With Card"}
        buttonText={submitBtnText}
        customerValidation={true}
        alpha2={account && account.currency && account.currency.countryAlpha2}
        currentDateObject={null}
        disableButtonText={null}
        planStartDate={null}
        showAddress={false}
        cancelButtonText={"Cancel"}
        showCancelBtn={true}
        cancel={cancelAlertOpen}
      />
    }
  ];


  return (
    <>
      <BaseSplitPage 
      errorHeader={null}
      errorMsg={errorMessage}
      left={
        <>
          <FlexContainer
            flexDirection="column"
            position="relative"
            display="block"
            height="100%"
          >
            <EcwidLeftSideContent order={order}/>
            <div style={{ position: "sticky", top: "85%" }}>
              <Support email={order && order.support && order.support.email}
                       phone={order && order.support && order.support.phone} />
            </div>
          </FlexContainer>
        </>
      } right={
        <>
          <SmallScreenHeader>
            <EcwidLeftSideContent order={order}/>
          </SmallScreenHeader>
          <PaymentMethodTabs
            name={ecwidOrderGid}
            paymentTypes={account && account.currency && account.currency.countryAlpha2}
            tabs={getMenuTabs([TabNames.CARD])}
            tabPanels={tabPanels}
            defaultSelectedTab={selectedTab || 0}
            onSelect={data => setSelectedTab(data)}
            upiDown={upiDownTime}
          />
          <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
          <SuccessModal isOpen={isTransactionSuccessModalOpen}  partnerConnection={false} successMsg={null}/>
          <Spinner isOpen={isShowSpinner} />
          <AlertModal
            showIcon={alertConfig.showIcon}
            isOpen={alertConfig.isOpen}
            hideBtn={alertConfig.hideBtn}
            cancel={alertConfig.cancel}
            header={alertConfig.header}
            body={alertConfig.body}
            submitBtnText={alertConfig.submitBtnText}
            cancelBtnText={alertConfig.cancelBtnText}
            showCancelBtn={alertConfig.showCancelBtn}
            showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon}/>
        </>
      } />
      );
    </>
  )
};

export default EcwidPayment
